import React from "react";
import { ProductListingView } from "..";
import AddToCartErrorMessage from "./AddToCartErrorMessage";

interface AddToCartErrorMessageWrapperProps {
  errorMessage: string | undefined;
  isInStock: boolean;
  productListingView: ProductListingView;
}

const AddToCartErrorMessageWrapper = ({
  errorMessage,
  isInStock,
  productListingView,
}: AddToCartErrorMessageWrapperProps) => {
  const displayErrorMessage =
    productListingView !== "topProductsCarousel" && errorMessage;

  return (
    <>
      {displayErrorMessage && (
        <AddToCartErrorMessage {...{ errorMessage, isInStock }} />
      )}
    </>
  );
};

export default AddToCartErrorMessageWrapper;
